export { default } from './FormGeneratorAutocompleteCDS';
